import React from "react";
import HomeContent from "./static/HomeContent";

export default function Home() {
  return <HomeContent />;
}
